import { navAutomotiveMenu, navAutomotivePromo } from './automotive';
import { navDiscountsMenu, navDiscountsPromo } from './discounts';
import { navFinancialMenu, navFinancialPromo } from './financial';
import { navInsuranceMenu, navInsurancePromo } from './insurance';
import { navMembershipMenu, navMembershipPromo } from './membership';
import { navTrafficSafetyMenu, navTrafficSafetyPromo } from './traffic-safety';
import { navTravelMenu, navTravelPromo } from './travel';

export const menu = [
  {
    key: 'membership',
    url: '/membership',
    label: 'Membership',
    promo: navMembershipPromo,
    menu: navMembershipMenu,
  },
  {
    key: 'travel',
    url: '/travel',
    label: 'Travel & Maps',
    promo: navTravelPromo,
    menu: navTravelMenu,
  },
  {
    key: 'automotive',
    url: '/automotive',
    label: 'Automotive',
    promo: navAutomotivePromo,
    menu: navAutomotiveMenu,
  },
  {
    key: 'insurance',
    url: '/insurance',
    label: 'Insurance',
    promo: navInsurancePromo,
    menu: navInsuranceMenu,
  },
  {
    key: 'discounts',
    url: 'https://carolinas.discounts.aaa.com/deal/overview',
    label: 'Discounts',
    promo: navDiscountsPromo,
    menu: navDiscountsMenu,
  },
  {
    key: 'financial',
    url: '/financial',
    label: 'Financial',
    promo: navFinancialPromo,
    menu: navFinancialMenu,
  },
  {
    key: 'traffic-safety',
    url: '/traffic-safety',
    label: 'Traffic Safety',
    promo: navTrafficSafetyPromo,
    menu: navTrafficSafetyMenu,
  },
];

export const menuTMIC = [
  {
    key: 'why-aaa',
    label: 'Why AAA Insurance?',
    url: 'https://carolinas.aaa.com/tmic/why-tmic/',
  },
  {
    key: 'get-quote',
    label: 'Get A Quote',
    url: 'https://www.aaacarolinasinsurancesolutions.com/quote/html/',
  },
  {
    key: 'products',
    label: 'Products',
    url: 'https://carolinas.aaa.com/tmic/products/',
  },
  {
    key: 'find-agent',
    label: 'Find An Agent',
    url: 'http://locator.carolinas.aaa.com/insurance',
  },
  {
    key: 'file-claims',
    label: 'File Claims',
    url: 'https://carolinas.aaa.com/tmic/manage-policy',
  },
];

export const menuUIC = [
  {
    key: 'auto',
    label: 'Auto',
    url: 'https://carolinas.aaa.com/insurance/products/auto-2/',
  },
  {
    key: 'motorcycle',
    label: 'Motorcycle',
    url: 'https://carolinas.aaa.com/uic/motorcycle//quote/html/',
  },
  {
    key: 'why-uic',
    label: 'Why UIC?',
    url: 'https://carolinas.aaa.com/uic/why-uic/',
  },
  {
    key: 'partner-uic',
    label: 'Partner with UIC',
    url: 'https://carolinas.aaa.com/uic/partner-with-us/',
  },
  {
    key: 'customer-service',
    label: 'Customer Service',
    url: 'https://carolinas.aaa.com/uic/customer-service/',
  },
  {
    key: 'find-agent',
    label: 'Find An Agent',
    url: 'http://locator.carolinas.aaa.com/insurance',
  },
  {
    key: 'file-claim',
    label: 'File a Claim',
    url: 'https://carolinas.aaa.com/tmic/manage-policy/',
  },
];
